/**
 * Serviço para integração com a Meta Conversions API (CAPI)
 * Envia eventos diretamente do cliente/servidor para o Facebook
 */

const PIXEL_ID = '957918106666803';
const ACCESS_TOKEN = import.meta.env.VITE_TOKEN_META;
const API_VERSION = 'v18.0';

export const sendMetaCapiEvent = async (eventName, userData = {}) => {
  if (!ACCESS_TOKEN) {
    console.warn('Meta CAPI: TOKEN_META não encontrado no ambiente.');
    return;
  }

  const url = `https://graph.facebook.com/${API_VERSION}/${PIXEL_ID}/events?access_token=${ACCESS_TOKEN}`;

  // Timestamp Unix atual
  const eventTime = Math.floor(Date.now() / 1000);

  const payload = {
    data: [
      {
        event_name: eventName,
        event_time: eventTime,
        action_source: "website",
        event_source_url: window.location.href,
        user_data: {
          client_user_agent: navigator.userAgent,
          // Adicione hashes (SHA256) de e-mail ou telefone se disponíveis
          ...userData
        },
        original_event_data: {
          event_name: eventName,
          event_time: eventTime
        }
      }
    ]
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    console.log(`Meta CAPI (${eventName}):`, result);
    return result;
  } catch (error) {
    console.error(`Erro ao enviar Meta CAPI (${eventName}):`, error);
  }
};